import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20product%20arrangement%20on%20creamy%20marble%20surface%20with%20soft%20morning%20light%20casting%20gentle%20shadows%2C%20scattered%20almond%20blossoms%20for%20natural%20accent%2C%20warm%20neutral%20palette%20with%20subtle%20terracotta%20and%20sand%20touches%2C%20sophisticated%20minimal%20composition%2C%20clean%20luxurious%20texture&width=1800&height=900&seq=hero-bg-v2-2607&orientation=landscape"
          alt="Superbuy Spreadsheet curated product collection background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1400px] mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-background-50 tracking-wide">
                Updated Daily &bull; 2026 Edition
              </span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              Superbuy Spreadsheet
              <br />
              <span className="text-accent-300 italic font-normal">
                The Ultimate Hub For Smart Shopping
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              Find the latest Superbuy spreadsheets, verified product collections, QC guides and
              shopping resources in one organized platform. Browse 14 curated categories updated
              regularly.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Buy it Now
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <Link
                to="/superbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Read Complete Guide
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 justify-center lg:justify-start">
              {[
                'Updated Spreadsheet Database',
                'Organized Product Categories',
                'Beginner Friendly Guides',
                'Secure Shopping Education',
              ].map((badge) => (
                <div
                  key={badge}
                  className="flex items-center gap-1.5 text-xs text-background-50/70"
                >
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                  <span>{badge}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Curated%20fashion%20pieces%20displayed%20on%20a%20warm%20oak%20floating%20shelf%20against%20a%20textured%20plaster%20wall%2C%20soft%20directional%20lighting%20from%20right%20creating%20depth%2C%20earthy%20terracotta%20and%20cream%20garments%20with%20organic%20folds%2C%20elegant%20boutique%20display%20aesthetic%2C%20warm%20inviting%20atmosphere&width=800&height=1000&seq=hero-side-v2-2607&orientation=portrait"
                  alt="Superbuy Spreadsheet curated products showcase"
                  className="w-full h-full object-cover aspect-[4/5]"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl p-3 shadow-lg">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-sparkling-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">500+ Finds</p>
                    <p className="text-[10px] text-foreground-500">Updated this week</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}